import type { DisplayCurrency } from "../../shared/money";
import { useI18n } from "../i18n/I18nProvider";
import { ALLOW_USD, useMoney } from "../lib/CurrencyProvider";

const OPTIONS: { value: DisplayCurrency; label: string }[] = [
  { value: "USD", label: "US$" },
  { value: "ARS", label: "AR$" },
];

/** Dollars (default) or pesos at the dólar blue + 5%; hidden while the rate is unknown. */
export function CurrencySwitcher() {
  const { t } = useI18n();
  const { currency, setCurrency, canShowArs } = useMoney();
  if (!ALLOW_USD || !canShowArs) return null;
  return (
    <div className="lang-switch" role="group" aria-label={t("currency.label")}>
      {OPTIONS.map((o) => (
        <button
          key={o.value}
          type="button"
          className={o.value === currency ? "lang-btn is-active" : "lang-btn"}
          aria-pressed={o.value === currency}
          title={t(o.value === "USD" ? "currency.usd" : "currency.ars")}
          onClick={() => setCurrency(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
